export const environment = {
  production: false,
  supabaseUrl: 'https://uffkhkawhpthjxqbplmo.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVmZmtoa2F3aHB0aGp4cWJwbG1vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODMyNzM0NzAsImV4cCI6MjA5ODg0OTQ3MH0.0WDO9xzp1zRAGp6ly4NNxy1n-4Cpv5HZXzH128njvy8',
  oauthRedirectUrl: '',
};
